import {Logger} from '@mamdev/cad.static-next-lib';
import Ads from './ads';
import Script from './script';

/**
 * Service to load and start the AdService
 */
class ASLoader {
  /**
   *
   */
  constructor() {
    this.baseUrl_ = undefined;
    this.configFileUrl_ = undefined;
    this.adComponentsLoaded_ = {
      bundle: false,
      config: false
    };
    this.perf_ = null;
  }

  /**
   * Sets the base URL for loading ad components
   * @param {string} val
   */
  set baseUrl(val) {
    this.baseUrl_ = val;
  }

  /**
   * Sets the URL for the correct config file to load
   * @param {string} val
   */
  set configFileUrl(val) {
    this.configFileUrl_ = val;
  }

  /**
   * Logs a message
   * @param {string} message
   */
  log(message) {
    Logger.log('asloader', message);
  }

  /**
   * Logs an error message
   * @param {string} message
   */
  logError(message) {
    Logger.log('asloader', message, false, console.error);
  }

  /**
   * Runs the service
   */
  run() {
    this.log('run');
    this.log('base url = ' + this.baseUrl_);

    this.perf_ = window.performance || {mark: () => {}};
    this.defaultConfigUrl = this.baseUrl_ + 'defaultConfig.js';

    this.loadAdServiceBundle();
    this.loadAdServiceConfig(() => {
      this.setAdComponentLoaded('config');
    }, () => {
      this.useDefaultConfig();
    });
  }

  /**
   * Load the AdService
   */
  loadAdServiceBundle() {
    const adServiceUrl = window.ui.AdServiceAlternativeUrl || window.ui.AdServiceConfig.adServiceBundleUrl;
    if (adServiceUrl) {
      Script.fetch(adServiceUrl).then(() => {
        this.setAdComponentLoaded('bundle');
      }).catch(() => {
        this.setAdComponentLoaded('bundle');
      });
    }
  }

  /**
   * Loads the config file for the current page.
   * @param {function} cb
   * @param {function} errCb
   */
  loadAdServiceConfig(cb, errCb) {
    if (this.configFileUrl_) {
      Script.fetch(this.configFileUrl_)
        .then(() => this.setAdComponentLoaded('config'))
        .catch(() => {
          this.logError('Unable to fetch config file');
          this.useDefaultConfig();
        });
    } else {
      this.log('Missing config file url');
      this.useDefaultConfig();
    }
  }

  /**
   * Load the default config file for the AdService, in case the one for the current page couldn't be loaded.
   */
  useDefaultConfig() {
    this.log('Use default config');

    Script.fetch(this.defaultConfigUrl)
      .then(() => this.setAdComponentLoaded('config'))
      .catch(() => this.logError('Unable to fetch default config file'));
  }

  /**
   * Keeps track of which ad components have been loaded.
   * Starts the AdService once all components have been loaded.
   * @param {string} component
   */
  setAdComponentLoaded(component) {
    this.adComponentsLoaded_[component] = true;

    this.log('component loaded: ' + component);

    if (this.adComponentsLoaded_.bundle && this.adComponentsLoaded_.config) {
      this.log('all components loaded: starting ads');
      this.perf_.mark('adservice-init-start');
      Ads.initialize();
      this.perf_.mark('adservice-init-end');
    }
  }
}

export default new ASLoader();
